import React from "react";
import { CloseIcon } from "asset/icons";
import TRC20 from "asset/icons/TRC20.svg";
import BEP20 from "asset/icons/BEP20.svg";
import CELO from "asset/icons/CELO.svg";
import SOL from "asset/icons/SOL.svg";
import { BaseIcon, EthIcon, PolygonIcon } from "asset/network-bank-icons";

const pickNetworkIcon = (value = "") => {
    const key = String(value || "").toLowerCase();

    if (key.includes("erc") || key.includes("ethereum") || key.includes("eth")) {
        return <EthIcon className="h-8 w-8" />;
    }
    if (key.includes("trc") || key.includes("tron")) {
        return <img src={TRC20} alt="TRC20" className="h-8 w-8" />;
    }
    if (key.includes("bep") || key.includes("bsc") || key.includes("bnb")) {
        return <img src={BEP20} alt="BEP20" className="h-8 w-8" />;
    }
    if (key.includes("polygon") || key.includes("matic")) {
        return <PolygonIcon className="h-8 w-8" />;
    }
    if (key.includes("base")) {
        return <BaseIcon className="h-8 w-8" />;
    }
    if (key.includes("celo")) {
        return <img src={CELO} alt="Celo" className="h-8 w-8" />;
    }
    if (key.includes("sol") || key.includes("solana")) {
        return <img src={SOL} alt="Solana" className="h-8 w-8" />;
    }

    return <EthIcon className="h-8 w-8" />;
};

const withCode = (value, code) =>
    [String(value ?? "").trim(), String(code ?? "").toUpperCase()].filter(Boolean).join(" ");

export default function CryptoConversionConfirmModal({
    isOpen,
    onClose,
    onConfirm,
    amount,
    convertedAmount,
    fee,
    fromCurrency,
    toCurrency,
    fromNetwork,
    toNetwork,
}) {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/40">
            <div className="bg-white rounded-2xl w-full max-w-xl relative">
                <div className="px-6 pt-6">
                    <button
                        onClick={onClose}
                        className="absolute top-5 right-5 text-gray-500 hover:text-black"
                    >
                        <CloseIcon />
                    </button>

                    <h2 className="text-[24px] font-[600] mb-10 text-[#101828]">
                        Confirm conversion details
                    </h2>

                    <div className="flex justify-around items-start mb-8">
                        <div className="flex flex-col items-center text-center">
                            <span className="text-[24px] font-[450] text-[#101828] mb-6">
                                {withCode(amount, fromCurrency)}
                            </span>
                            <span className="border rounded-full w-[74px] h-[74px] flex items-center justify-center text-[22px] font-semibold text-[#344054]">
                                {pickNetworkIcon(fromNetwork)}
                            </span>
                            <span className="text-md text-gray-400 mt-4">From</span>
                            <span className="!text-lg font-[400] text-[#101828] mt-1">
                                {fromNetwork || "—"}
                            </span>
                        </div>

                        <span className="text-3xl text-gray-400 mt-10">→</span>

                        <div className="flex flex-col items-center text-center">
                            <span className="text-[24px] font-[450] text-[#101828] mb-6">
                                {withCode(convertedAmount, toCurrency)}
                            </span>
                            <span className="border rounded-full w-[74px] h-[74px] flex items-center justify-center text-[22px] font-semibold text-[#344054]">
                                {pickNetworkIcon(toNetwork)}
                            </span>
                            <span className="text-md text-gray-400 mt-4">To</span>
                            <span className="!text-lg font-[400] text-[#101828] mt-1">
                                {toNetwork || "—"}
                            </span>
                        </div>
                    </div>

                    <div className="border-t pt-4 !text-[16px] text-[#161827] font-thin">
                        <div className="flex justify-between">
                            <span>Conversion fee</span>
                            <span>{withCode(fee, fromCurrency)}</span>
                        </div>
                    </div>
                </div>

                <div className="mt-6 flex justify-end gap-4 px-6 pb-6 border-t pt-3">
                    <button onClick={onClose} className="text-[#344054] font-medium text-sm">
                        Cancel
                    </button>
                    <button
                        onClick={onConfirm}
                        className="bg-[#6F00FF] text-white px-6 !py-3 rounded-lg font-medium text-sm"
                    >
                        Confirm and convert
                    </button>
                </div>
            </div>
        </div>
    );
}
